import { render, staticRenderFns } from "./Companydetails.vue?vue&type=template&id=2a5222c9"
import script from "./Companydetails.vue?vue&type=script&lang=js"
export * from "./Companydetails.vue?vue&type=script&lang=js"
import style0 from "./Companydetails.vue?vue&type=style&index=0&id=2a5222c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports